import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_ACCOUNT_ACTIVITY } from 'actions/apiActionConstants'
import requestLoyaltyAccountActivity from 'api/loyalty/requestLoyaltyAccountActivity'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'

function fetchLoyaltyAccountActivity(startDate: string, endDate: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const memberId = state.auth.account.memberId
    const hasLoyaltyAccount = getHasLoyaltyAccount(state)

    const accountActivity = state.loyalty.accountActivity
    if (
      !getIsLoyaltyEnabled(state) ||
      !memberId ||
      !hasLoyaltyAccount ||
      // already have the data, no need to refetch it
      accountActivity.fetching || accountActivity.data || accountActivity.error
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_ACCOUNT_ACTIVITY,
      request: () => requestLoyaltyAccountActivity(memberId, startDate, endDate),
    })
  }
}

export default fetchLoyaltyAccountActivity
